import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  POST: 'DEMO_SLOTS_POST',
  POST_SUCCESS: 'DEMO_SLOTS_POST_SUCCESS',
  POST_FAILURE: 'DEMO_SLOTS_POST_FAILURE',
};

export const post = actions.post(
  (id, value, { studentId }) => `${BASE_URL}/students/${studentId}/demo-slots/`,
  {
    PENDING: ACTIONS.POST,
    SUCCESS: ACTIONS.POST_SUCCESS,
    FAILURE: ACTIONS.POST_FAILURE,
  },
);
